import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const MenuContainer = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const ButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));

interface StyledIconButtonProps {
  selected: boolean;
}

export const StyledIconButton = styled(IconButton)<StyledIconButtonProps>(
  ({ selected }) => ({
    padding: 4,
    borderRadius: 4,
    ...(selected && {
      backgroundColor: '#F0EEED',
    }),
  })
);

export const StyledHeadIconButton = styled(IconButton)<StyledIconButtonProps>(
  ({ selected }) => ({
    padding: 4,
    borderRadius: 4,
    span: {
      fontSize: '23px',
      fontFamily: 'arial',
      textTransform: 'capitalize',
    },
    ...(selected && {
      backgroundColor: '#F0EEED',
    }),
  })
);
